import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatBotComponent } from './components/chat-bot/chat-bot.component'; // update path if needed
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';
PlotlyModule.plotlyjs = PlotlyJS;
import { PaginationComponent } from './components/pagination/pagination.component';
import { LoaderMainComponent } from './components/loader-main/loader-main.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ChartPopupComponent } from './components/chart-popup/chart-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { ClearFiltersComponent } from './components/clear-filters/clear-filters.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ResetPasswordDialogComponent } from './components/reset-password-dialog/reset-password-dialog.component';

import { MatDatepicker } from '@angular/material/datepicker';
import { MatFormField } from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MaterialDatePickerCellEditor } from './components/material-date-picker-cell-editor/material-date-picker-cell-editor.component';
import { AcademicYearBadgeComponent } from './components/academic-year-badge/academic-year-badge.component';
import { CurrencyShortPipe } from './pipe/currency-short.pipe';
import { IndianCurrencyPipe } from './pipe/indian-currency.pipe';
import { BlankIfNaPipe } from './pipe/blank-if-na.pipe';
import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { FilterToggleComponent } from './filter-toggle/filter-toggle.component';
import { AutoPageSizeDirective } from './directives/auto-page-size.directive';
import { AgGridHeaderTooltipDirective } from './directives/ag-grid-header-tooltip.directive';
import { NoScrollNumberDirective } from './directives/no-scroll-number.directive';
import { GlobalSearchComponent } from './global-search/global-search.component';
import { DateFilterComponent } from './components/date-filter/date-filter.component';
import { ColumnPickerComponent } from './components/column-picker/column-picker.component';
import { EmailReportDialogComponent } from './components/email-report-dialog/email-report-dialog.component';
import { ReportPageLayoutComponent } from './components/report-page-layout/report-page-layout.component';
import { SmsDialogComponent } from './components/sms-dialog/sms-dialog.component';
import { SmsConfirmDialogComponent } from './components/sms-dialog/sms-confirm-dialog/sms-confirm-dialog.component';
// Legacy generic confirm-dialog (still used by feature components that import
// it directly and pass it to MatDialog.open). Declared here so its template
// can resolve <sms-dialog> after the modal-shell migration.
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { FilterPanelComponent } from './components/filter-panel/filter-panel.component';
import { AgGridModule } from 'ag-grid-angular';
import { RouterModule } from '@angular/router';
import { A11yModule } from '@angular/cdk/a11y';
@NgModule({
  declarations: [
    ChatBotComponent,
    PaginationComponent,
    PaginationComponent,
    LoaderMainComponent,
    ChartPopupComponent,
    ClearFiltersComponent,
    ResetPasswordDialogComponent,
    MaterialDatePickerCellEditor,
    AcademicYearBadgeComponent,
    CurrencyShortPipe,
    IndianCurrencyPipe,
    BlankIfNaPipe,
    SearchableSelectComponent,
    FilterToggleComponent,
    AutoPageSizeDirective,
    AgGridHeaderTooltipDirective,
    NoScrollNumberDirective,
    GlobalSearchComponent,
    DateFilterComponent,
    ColumnPickerComponent,
    EmailReportDialogComponent,
    ReportPageLayoutComponent,
    SmsDialogComponent,
    SmsConfirmDialogComponent,
    ConfirmDialogComponent,
    FilterPanelComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PlotlyModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatDividerModule,
    AgGridModule,
    RouterModule,
    A11yModule,
  ],
  exports: [
    ChatBotComponent,
    PaginationComponent,
    LoaderMainComponent,
    ClearFiltersComponent,
    AcademicYearBadgeComponent,
    CurrencyShortPipe,
    IndianCurrencyPipe,
    BlankIfNaPipe,
    SearchableSelectComponent,
    FilterToggleComponent,
    AutoPageSizeDirective,
    AgGridHeaderTooltipDirective,
    NoScrollNumberDirective,
    GlobalSearchComponent,
    DateFilterComponent,
    ColumnPickerComponent,
    EmailReportDialogComponent,
    ReportPageLayoutComponent,
    SmsDialogComponent,
    SmsConfirmDialogComponent,
    FilterPanelComponent,
  ],
})
export class SharedModule {}
